"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _StatusMessageDTO = _interopRequireDefault(require("../model/StatusMessageDTO"));

var _TreatmentPlanRequestDtoV = _interopRequireDefault(require("../model/TreatmentPlanRequestDtoV2"));

var _TreatmentPlanRequestEntityDtoV = _interopRequireDefault(require("../model/TreatmentPlanRequestEntityDtoV2"));

var _TreatmentPlanRequestEntityDtoV2PaginatedList = _interopRequireDefault(require("../model/TreatmentPlanRequestEntityDtoV2PaginatedList"));

var _TreatmentPlanRequestMetadataDtoV = _interopRequireDefault(require("../model/TreatmentPlanRequestMetadataDtoV2"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
* TreatmentPlanRequests service.
* @module 2/TreatmentPlanRequestsApi
* @version 1.1.1
*/
var TreatmentPlanRequestsApi = /*#__PURE__*/function () {
  /**
  * Constructs a new TreatmentPlanRequestsApi. 
  * @alias module:2/TreatmentPlanRequestsApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function TreatmentPlanRequestsApi(apiClient) {
    _classCallCheck(this, TreatmentPlanRequestsApi);

    this.apiClient = apiClient || _ApiClient["default"].instance;
  }
  /**
   * Gets a list of all available treatment plan requests.
   * The returned list includes only those treatment plan requests which the client  is allowed to access (client identification is derived from the access token).
   * @param {Object} opts Optional parameters
   * @param {String} opts.requestState The request state of interest.
   * @param {Array.<String>} opts.applicationType The type of the application of interest.
   * @param {Array.<String>} opts.regions The regions of interest.
   * @param {String} opts.externalReference The descriptor of interest.
   * @param {Boolean} opts.includeAcknowledgedRequests If set to {true} already acknowledged requests              shall be included as part of the response. (default to false)
   * @param {String} opts.dateTimeFrom The start date for retrieving treatment plan requests.
   * @param {String} opts.dateTimeTo The end date for retrieving treatment plan requests.
   * @param {String} opts.additionalDataFilter The additional data filter.              <br>              Must be a valid, flat JSON object or array like <code> [ {\"caseID\":\"0007\", \"status.inDesign\": true}, { \"dateTimeCreated\" : \"2020-04-14T10:15:00Z\" } ]</code>.              <br>              When adding additional data, <b> numbers must be added strings </b> for the search to work. Booleans must be added as booleans.              <br>              DateTimes must be exact string matches to what has been added. <code>\"2020-04-14T10:15:00.000Z\"</code> won't be treated as the same as above.              <br>              Searching for null/not-exist is supported, like <code> { \"implant.extraSize\": null } </code>.              
   * @param {String} opts.sort The sorting criterion.               <br>Must be a flat object like <code> externalReference:asc </code> or <code> additionalData.surgeryDate:desc</code>
   * @param {Number} opts.pageIndex Index of the page. The first page has index zero. (default to 0)
   * @param {Number} opts.pageSize Size of the page, that is the number of objects on a page.              For a size smaller than one, all objects are returned. (default to 20)
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/TreatmentPlanRequestEntityDtoV2PaginatedList} and HTTP response
   */


  _createClass(TreatmentPlanRequestsApi, [{
    key: "treatmentplanrequestsGetWithHttpInfo",
    value: function treatmentplanrequestsGetWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        'requestState': opts['requestState'],
        'applicationType': this.apiClient.buildCollectionParam(opts['applicationType'], 'multi'),
        'regions': this.apiClient.buildCollectionParam(opts['regions'], 'multi'),
        'externalReference': opts['externalReference'],
        'includeAcknowledgedRequests': opts['includeAcknowledgedRequests'],
        'dateTimeFrom': opts['dateTimeFrom'],
        'dateTimeTo': opts['dateTimeTo'],
        'additionalDataFilter': opts['additionalDataFilter'],
        'sort': opts['sort'],
        'pageIndex': opts['pageIndex'],
        'pageSize': opts['pageSize']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _TreatmentPlanRequestEntityDtoV2PaginatedList["default"];
      return this.apiClient.callApi('/treatmentplanrequests', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Gets a list of all available treatment plan requests.
     * The returned list includes only those treatment plan requests which the client  is allowed to access (client identification is derived from the access token).
     * @param {Object} opts Optional parameters
     * @param {String} opts.requestState The request state of interest.
     * @param {Array.<String>} opts.applicationType The type of the application of interest.
     * @param {Array.<String>} opts.regions The regions of interest.
     * @param {String} opts.externalReference The descriptor of interest.
     * @param {Boolean} opts.includeAcknowledgedRequests If set to {true} already acknowledged requests              shall be included as part of the response. (default to false)
     * @param {String} opts.dateTimeFrom The start date for retrieving treatment plan requests.
     * @param {String} opts.dateTimeTo The end date for retrieving treatment plan requests.
     * @param {String} opts.additionalDataFilter The additional data filter.              <br>              Must be a valid, flat JSON object or array like <code> [ {\"caseID\":\"0007\", \"status.inDesign\": true}, { \"dateTimeCreated\" : \"2020-04-14T10:15:00Z\" } ]</code>.              <br>              When adding additional data, <b> numbers must be added strings </b> for the search to work. Booleans must be added as booleans.              <br>              DateTimes must be exact string matches to what has been added. <code>\"2020-04-14T10:15:00.000Z\"</code> won't be treated as the same as above.              <br>              Searching for null/not-exist is supported, like <code> { \"implant.extraSize\": null } </code>.              
     * @param {String} opts.sort The sorting criterion.               <br>Must be a flat object like <code> externalReference:asc </code> or <code> additionalData.surgeryDate:desc</code>
     * @param {Number} opts.pageIndex Index of the page. The first page has index zero. (default to 0)
     * @param {Number} opts.pageSize Size of the page, that is the number of objects on a page.              For a size smaller than one, all objects are returned. (default to 20)
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/TreatmentPlanRequestEntityDtoV2PaginatedList}
     */

  }, {
    key: "treatmentplanrequestsGet",
    value: function treatmentplanrequestsGet(opts) {
      return this.treatmentplanrequestsGetWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Deletes the specified treatment plan request.
     * @param {String} id The request identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "treatmentplanrequestsIdDeleteWithHttpInfo",
    value: function treatmentplanrequestsIdDeleteWithHttpInfo(id) {
      var postBody = null; // verify the required parameter 'id' is set

      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling treatmentplanrequestsIdDelete");
      }

      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = null;
      return this.apiClient.callApi('/treatmentplanrequests/{id}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Deletes the specified treatment plan request.
     * @param {String} id The request identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "treatmentplanrequestsIdDelete",
    value: function treatmentplanrequestsIdDelete(id) {
      return this.treatmentplanrequestsIdDeleteWithHttpInfo(id).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Gets the specified treatment plan request.
     * @param {String} id The request identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/TreatmentPlanRequestEntityDtoV2} and HTTP response
     */

  }, {
    key: "treatmentplanrequestsIdGetWithHttpInfo",
    value: function treatmentplanrequestsIdGetWithHttpInfo(id) {
      var postBody = null; // verify the required parameter 'id' is set

      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling treatmentplanrequestsIdGet");
      }

      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _TreatmentPlanRequestEntityDtoV["default"];
      return this.apiClient.callApi('/treatmentplanrequests/{id}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Gets the specified treatment plan request.
     * @param {String} id The request identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/TreatmentPlanRequestEntityDtoV2}
     */

  }, {
    key: "treatmentplanrequestsIdGet",
    value: function treatmentplanrequestsIdGet(id) {
      return this.treatmentplanrequestsIdGetWithHttpInfo(id).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Updates the specified treatment plan request.
     * This operation expects the complete treatment plan request record to be provided  to enable detection of all updated information, including potentially removed  properties.  The data and time of the last modification must exactly match the value which  has been receivend upon loading the record. This is important to enable detection  of potential version conflicts in case the record might get modified by multiple  users simultaneously.
     * @param {String} id The request identifier.
     * @param {String} dateTimeLastModified The date and time when the request was last modified.
     * @param {module:model/TreatmentPlanRequestDtoV2} treatmentPlanRequestDtoV2 The request to update.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/TreatmentPlanRequestMetadataDtoV2} and HTTP response
     */

  }, {
    key: "treatmentplanrequestsIdPutWithHttpInfo",
    value: function treatmentplanrequestsIdPutWithHttpInfo(id, dateTimeLastModified, treatmentPlanRequestDtoV2) {
      var postBody = treatmentPlanRequestDtoV2; // verify the required parameter 'id' is set

      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling treatmentplanrequestsIdPut");
      } // verify the required parameter 'dateTimeLastModified' is set


      if (dateTimeLastModified === undefined || dateTimeLastModified === null) {
        throw new Error("Missing the required parameter 'dateTimeLastModified' when calling treatmentplanrequestsIdPut");
      } // verify the required parameter 'treatmentPlanRequestDtoV2' is set


      if (treatmentPlanRequestDtoV2 === undefined || treatmentPlanRequestDtoV2 === null) {
        throw new Error("Missing the required parameter 'treatmentPlanRequestDtoV2' when calling treatmentplanrequestsIdPut");
      }

      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {
        'dateTimeLastModified': dateTimeLastModified
      };
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = ['application/json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _TreatmentPlanRequestMetadataDtoV["default"];
      return this.apiClient.callApi('/treatmentplanrequests/{id}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Updates the specified treatment plan request.
     * This operation expects the complete treatment plan request record to be provided  to enable detection of all updated information, including potentially removed  properties.  The data and time of the last modification must exactly match the value which  has been receivend upon loading the record. This is important to enable detection  of potential version conflicts in case the record might get modified by multiple  users simultaneously.
     * @param {String} id The request identifier.
     * @param {String} dateTimeLastModified The date and time when the request was last modified.
     * @param {module:model/TreatmentPlanRequestDtoV2} treatmentPlanRequestDtoV2 The request to update.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/TreatmentPlanRequestMetadataDtoV2}
     */

  }, {
    key: "treatmentplanrequestsIdPut",
    value: function treatmentplanrequestsIdPut(id, dateTimeLastModified, treatmentPlanRequestDtoV2) {
      return this.treatmentplanrequestsIdPutWithHttpInfo(id, dateTimeLastModified, treatmentPlanRequestDtoV2).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Creates and stores a new treatment plan request.
     * @param {String} workflow The workflow.
     * @param {module:model/TreatmentPlanRequestDtoV2} treatmentPlanRequestDtoV2 The object that contains all required information to create a new request.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/TreatmentPlanRequestMetadataDtoV2} and HTTP response
     */

  }, {
    key: "treatmentplanrequestsPostWithHttpInfo",
    value: function treatmentplanrequestsPostWithHttpInfo(workflow, treatmentPlanRequestDtoV2) {
      var postBody = treatmentPlanRequestDtoV2; // verify the required parameter 'workflow' is set

      if (workflow === undefined || workflow === null) {
        throw new Error("Missing the required parameter 'workflow' when calling treatmentplanrequestsPost");
      } // verify the required parameter 'treatmentPlanRequestDtoV2' is set


      if (treatmentPlanRequestDtoV2 === undefined || treatmentPlanRequestDtoV2 === null) {
        throw new Error("Missing the required parameter 'treatmentPlanRequestDtoV2' when calling treatmentplanrequestsPost");
      }

      var pathParams = {};
      var queryParams = {
        'workflow': workflow
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _TreatmentPlanRequestMetadataDtoV["default"];
      return this.apiClient.callApi('/treatmentplanrequests', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Creates and stores a new treatment plan request.
     * @param {String} workflow The workflow.
     * @param {module:model/TreatmentPlanRequestDtoV2} treatmentPlanRequestDtoV2 The object that contains all required information to create a new request.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/TreatmentPlanRequestMetadataDtoV2}
     */

  }, {
    key: "treatmentplanrequestsPost",
    value: function treatmentplanrequestsPost(workflow, treatmentPlanRequestDtoV2) {
      return this.treatmentplanrequestsPostWithHttpInfo(workflow, treatmentPlanRequestDtoV2).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);

  return TreatmentPlanRequestsApi;
}();

exports["default"] = TreatmentPlanRequestsApi;